import { useEffect, useState } from 'react'

/**
 * @returns The current document title. Observes the title change and returns
 * the latest title.
 */
export function useDocumentTitle(): string {
  const [title, setTitle] = useState<string>(document.title)

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          setTitle(mutation.target.textContent ?? '')
        }
      })
    })
    let titleEl = document.querySelector('title')
    if (!titleEl) {
      titleEl = document.createElement('title')
      document.head.appendChild(titleEl)
    }
    observer.observe(titleEl, {
      childList: true,
    })
    return () => {
      observer.disconnect()
    }
  }, [])

  return title
}
